import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StringTransform from 'teacher-ui-client/transforms/string'

export default class StandardsSet extends Model {
  @attr<StringTransform>('string') declare name: string

  @attr<StringTransform>('string') declare code: string

  @attr<StringTransform>('string') declare countryCode: string;

  [Type] = 'standards-set' as const
}
